import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getMasterEntityTypeAsync,updateSorting } from './CustomFieldSlice';
import CustomPagination from "../../../common/Pagination";
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { KTIcon } from '../../../_metronic/helpers';
import {getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';

const CustomFieldItem = (props: any) => {
    const {t, IsEdit,masterEntityTypeList } = props;
    const {sortOrder, sortColumn,pageSize,isLoading } = useAppSelector((state) => state.customField);
    const { manageTerminologyList } = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();
    // const navigate = useNavigate();

    //const { masterEntityTypeList } = useAppSelector((state) => state.customField);
    // const handleManageCustomField = (MasterEntityTypeId: string) => {
    //     navigate(`/customFields?MasterEntityTypeId=${MasterEntityTypeId}`);
    // };

    useEffect(() => {
        localStorage.removeItem('ntitle');
    }, []);

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    return (
        <>
           {isLoading && <Loader />}
            <table className="table table-row-bordered  align-middle gs-1 gy-2 gx-1" >
                <thead>
                    <tr className="thHeading align-middle ">
                        <th className='min-w-95%'>
                            {/* {t('Master Entity Type Name')} */}
                            {getValueFromResource('Master Entity Type Name',dispatch, t)}

                        {sortColumn === 'MasterEntityTypeName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "MasterEntityTypeName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "MasterEntityTypeName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "MasterEntityTypeName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "MasterEntityTypeName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='min-w-5% text-end '></th>
                    </tr>
                </thead>
                <tbody>
                    {/* {masterEntityTypeList.length === 0 && <tr><td>{t('No Record Found.')}</td></tr>} */}
                    { masterEntityTypeList.length > 0 && masterEntityTypeList.map((masterEntityTypeDetail: any, i: any) => (
                        <tr key={i}>
                            <td>
                                {IsEdit ?
                                    (
                                        <Link to={`../CustomFieldManage?MasterEntityTypeId=${masterEntityTypeDetail.MasterEntityTypeId}`}
                                            className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <span className='d-block' >
                                               {getValueFromResource(masterEntityTypeDetail.MasterEntityTypeName, dispatch,t)} </span>
                                        </Link>
                                    ):
                                    (
                                        <span className='d-block' >
                                            {getValueFromResource(masterEntityTypeDetail.MasterEntityTypeName, dispatch,t)} </span>
                                    )
                            }
                            
                            </td>
                            {IsEdit &&
                                // <td className='text-end'>
                                //     <div className='d-flex justify-content-end flex-shrink-0'>
                                //         <Link to={`../CustomFieldManage?MasterEntityTypeId=${masterEntityTypeDetail.MasterEntityTypeId}`}
                                //             //className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                //             className='btn btn-icon  btn-sm me-1'
                                //         >
                                //             <i className="bi bi-receipt fs-3"></i>

                                //         </Link>

                                //     </div>
                                // </td>
                                <td className="text-end">
                                    <div className="d-flex justify-content-end flex-shrink-0">
                                        <Link
                                            to={`../CustomFieldManage?MasterEntityTypeId=${masterEntityTypeDetail.MasterEntityTypeId}`}
                                            className="btn btn-icon btn-sm me-1"
                                            data-tooltip-id="tooltip-Description"
                                            data-tooltip-content=
                                            // {t("Manage Custom Field")}
                                            {getValueFromResource('Manage Custom Field',dispatch, t)}
                                            data-tooltip-place="top"
                                        >
                                            
                                            <i className="bi bi-receipt fs-3"></i>
                                        </Link>

                                    </div>
                                </td>
                            }
                        </tr>
                    ))}

                </tbody>
            </table >
            {masterEntityTypeList.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}

                                            </p>
                                    </div>
                                }


        </>
    )
}

export default CustomFieldItem


////////////////

// import React, { useEffect, useState } from 'react'
// import { Dropdown } from 'react-bootstrap'
// import { useAppDispatch, useAppSelector } from '../../../app/hooks';
// import { getMasterEntityTypeAsync } from './CustomFieldSlice';
// import CustomPagination from "../../../common/Pagination";
// import { Link, useNavigate } from 'react-router-dom';
// import moment from 'moment';


// const CustomFieldItem = (props: any) => {
//     const { masterEntityTypeList,onLinkClicked } = props;
//     const dispatch = useAppDispatch();
//     const navigate = useNavigate();
//     //const { masterEntityTypeList } = useAppSelector((state) => state.customField);
//     const handleManageCustomField = (MasterEntityTypeId: string) => {
//         navigate(`/customFields?MasterEntityTypeId=${MasterEntityTypeId}`);
//         onLinkClicked();
//     };
    
//     useEffect(() => {
//         localStorage.removeItem('ntitle');
//     }, []);
    
//     return (
//         <>
//             <table className="table table-striped gy-7 gs-7">
//                 <thead>
//                     <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
//                         <th>Master Entity Type Name</th>
//                         <th></th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {masterEntityTypeList.length === 0 && <tr><td>No Record Found.</td></tr>}
//                     {masterEntityTypeList.length > 0 && masterEntityTypeList.map((masterEntityTypeObj: any, i: any) => (

//                         <tr key={i}>
//                             <td>
//                                 <Link to={`../CustomFieldManage?MasterEntityTypeId=${masterEntityTypeObj.MasterEntityTypeId}`} >
//                                     <span style={{ verticalAlign: '0.2em' }}>{masterEntityTypeObj.MasterEntityTypeName} </span>
//                                 </Link>
//                             </td>
//                             <td>
//                                 <Dropdown style={{ marginLeft: 1 }}>
//                                     <Dropdown.Toggle
//                                         variant="secondary"
//                                         className="btn btn-secondary btn-sm me-1 text-uppercase btn-icon-dark btn-text-dark"
//                                         style={{ fontSize: 11 }}
//                                     >
//                                         Options
//                                     </Dropdown.Toggle>
//                                     <Dropdown.Menu>
//                                         <Dropdown.Item
//                                             className="text-uppercase btn-icon-dark btn-text-dark"
//                                             style={{ fontSize: 11 }} 
//                                             >
//                                             <i className="bi bi-receipt fs-5 me-2"></i>
//                                             <Link to={`../CustomFieldManage?MasterEntityTypeId=${masterEntityTypeObj.MasterEntityTypeId}`} >
//                                                 <span style={{ verticalAlign: '0.2em' }}>Manage Custom Field</span>
//                                             </Link>
//                                         </Dropdown.Item>
//                                     </Dropdown.Menu>
//                                 </Dropdown>
//                             </td>
//                         </tr>
//                     ))}

//                 </tbody>
//             </table>
           
//         </>
//     )
// }

// export default CustomFieldItem